module.exports = __webpack_public_path__ + "./SherryPhoto_cfd20d96776318aa87c1bd2b04eaaed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/SherryPhoto.png
// module id = 507
// module chunks = 0